export enum LoginType {
  Email = "email",
  Phone = "phoneNumber",
}
